<app-landing-header></app-landing-header>

<div class="container">
  <div class="container-fluid">
    <div class="social-dash-wrap">
      <div class="row">
        <div class="card">
          <div class="card-body">
            <h2
              class="mb-3 text-center"
              [innerHTML]="'terms_of_use.title' | translate"
            >
              <!-- Terms of Service -->
            </h2>
            <div class="info-section">
              <p [innerHTML]="'terms_of_use.intro1' | translate">
                <!-- Welcome to Removia! These Terms of Service ("Terms") govern your
                use of Removia's data removal services and website at Removia.io
                ("Website"). These Terms form a binding legal agreement between
                GotYourBack Technologies Ltd. ("Removia," "we," "us," "our") and
                you ("you," "your"). -->
              </p>
              <p [innerHTML]="'terms_of_use.intro2' | translate">
                <!-- <b
                  >BY USING OUR SERVICES, YOU AGREE TO BE LEGALLY BOUND BY THESE
                  TERMS. IF YOU DO NOT ACCEPT ALL OF THESE TERMS, PLEASE DO NOT
                  USE OUR SERVICES.</b
                > -->
              </p>
            </div>
            <div class="info-section">
              <h5 [innerHTML]="'terms_of_use.section_1.title' | translate">
                <!-- 1. What is Removia? -->
              </h5>
              <p [innerHTML]="'terms_of_use.section_1.p1' | translate">
                <!-- Removia acts as your authorized agent to contact data brokers in
                the United States, Canada, European Union, and United Arab
                Emirates on your behalf. Our services include removing your
                personal information from data broker databases, opting you out
                of data sales and distribution, monitoring for new listings and
                submitting ongoing removal requests, and providing progress
                tracking through your personal dashboard. -->
              </p>
              <p [innerHTML]="'terms_of_use.section_1.p2' | translate">
                <!-- Data brokers are organizations that systematically gather
                personal information from public records, social media
                platforms, purchase histories, and other sources, then analyze
                and package this information into detailed personal profiles
                that they sell or distribute to third parties including
                marketers, employers, investigators, and other businesses, often
                operating without your explicit knowledge or consent. -->
              </p>
              <p [innerHTML]="'terms_of_use.section_1.p3' | translate">
                <!-- Our service works through a three-step process. First, you
                provide accurate personal information and sign authorization
                forms granting us legal authority to act on your behalf, and we
                verify your identity as required by data broker policies.
                Second, we scan data broker databases for your information,
                submit formal removal requests using applicable legal frameworks
                including GDPR and CCPA, and follow up with non-responsive
                brokers using established procedures. Third, we provide ongoing
                protection by regularly re-scanning data brokers every ninety
                days minimum, submitting new removal requests as needed, and
                providing detailed progress reports through your dashboard. -->
              </p>
              <p [innerHTML]="'terms_of_use.section_1.p4' | translate">
                <!-- Our geographic coverage includes the United States with all
                fifty states and territories, Canada with all provinces and
                territories, the European Union with all member states, and
                limited coverage in the United Arab Emirates with expansion
                planned based on local data protection law development. Data
                broker coverage varies by subscription plan, with our Lite Plan
                covering one hundred data brokers, Pro Plan covering one hundred
                fifty data brokers, Advanced Plan covering two hundred data
                brokers, and Ultimate Plan covering three hundred data brokers. -->
              </p>
              <p [innerHTML]="'terms_of_use.section_1.p5' | translate">
                <!-- To provide effective service, you must provide accurate and
                complete personal information including current and historical
                addresses, associated email addresses and phone numbers,
                alternative names or aliases you have used, and relevant date
                ranges. You must sign our authorization form, verify your
                identity when requested, and respond to verification requests
                from data brokers when necessary. If you provide inaccurate or
                incomplete information, we may not be able to successfully
                locate and remove your personal data from broker databases. -->
              </p>
            </div>
            <div class="info-section">
              <h5 [innerHTML]="'terms_of_use.section_2.title' | translate">
                <!-- 2. Eligibility and Account Requirements -->
              </h5>
              <p [innerHTML]="'terms_of_use.section_2.p1' | translate">
                <!-- To use our services, you must be eighteen years or older, have
                legal capacity to enter binding contracts, and be acting as an
                individual consumer for personal use rather than business or
                commercial purposes. Persons under eighteen are strictly
                prohibited from using our services under any circumstances. -->
              </p>
              <p [innerHTML]="'terms_of_use.section_2.p2' | translate">
                <!-- You must provide accurate and complete information during
                registration, create a secure password meeting our security
                requirements, and maintain only one active account per
                individual. You cannot transfer, sell, or assign your account to
                any other person. You are solely responsible for all activity
                under your account and must immediately notify us of any
                suspected unauthorized use, maintain current and accurate
                account information, and protect your login credentials from
                unauthorized access. -->
              </p>
              <p [innerHTML]="'terms_of_use.section_2.p3' | translate">
                <!-- We recommend using strong, unique passwords, logging out
                completely when using shared computers, enabling two-factor
                authentication when available, and regularly monitoring your
                account for suspicious activity. Each person may maintain only
                one active account, and creating multiple accounts for the same
                individual is prohibited and may result in termination of all
                associated accounts. -->
              </p>
              <p [innerHTML]="'terms_of_use.section_2.p4' | translate">
                <!-- Our service is intended for personal, non-commercial use only.
                You cannot use our service to remove information belonging to
                other individuals without proper authorization, request removal
                of legitimate public interest information such as court records,
                or circumvent legal requirements to maintain certain public
                records. Family plan members receive separate account access
                with individual dashboards and independent removal request
                management, while the primary account holder maintains billing
                responsibility and administrative control. -->
              </p>
            </div>
            <div class="info-section">
              <h5 [innerHTML]="'terms_of_use.section_3.title' | translate">
                <!-- 3. Subscription Plans and Features -->
              </h5>
              <p [innerHTML]="'terms_of_use.section_3.p1' | translate">
                <!-- The Company offers multiple subscription plans (“Subscription
                Plans”), which may vary in duration, functionality, price, and
                rebilling terms. The availability and scope of each Subscription
                Plan are subject to change at the Company’s discretion. -->
              </p>
              <p [innerHTML]="'terms_of_use.section_3.p2' | translate">
                <!-- Depending on the Subscription Plan selected, features may
                include, without limitation, coverage for one or more users and
                email addresses, contact with a defined number of data brokers,
                submission of removal requests (standard or priority), periodic
                re‑check cycles, progress reporting, analytics, and customer
                support tiers. Family‑oriented plans may additionally provide
                multi‑user account access, individual dashboards, personalized
                privacy settings, and centralized billing management. -->
              </p>
              <p [innerHTML]="'terms_of_use.section_3.p3' | translate">
                <!-- All Subscription Plans are designed to provide initial scanning
                of data broker networks, systematic removal request submission
                with follow‑up procedures, monitoring at least every ninety (90)
                days, secure dashboard access with real‑time progress tracking,
                and email notifications of significant updates. -->
              </p>
              <p [innerHTML]="'terms_of_use.section_3.p4' | translate">
                <!-- The specific conditions applicable to each Subscription Plan are
                disclosed on the purchase page and during the checkout process.
                The Company reserves the right to modify, add, or remove
                Subscription Plans, and to update their features, pricing, and
                billing policies. In the event of material changes, customers
                shall be notified at least thirty (30) days in advance, and such
                changes shall take effect at the start of the next billing
                cycle. Customers will have the right to cancel their
                Subscription Plan prior to the effective date of such changes,
                in accordance with applicable law. -->
              </p>
            </div>
            <div class="info-section">
              <h5 [innerHTML]="'terms_of_use.section_4.title' | translate">
                <!-- 4. Service Commitments -->
              </h5>
              <p [innerHTML]="'terms_of_use.section_4.p1' | translate">
                <!-- We commit to activating your account promptly upon payment
                processing and subscription confirmation, conducting initial
                comprehensive data broker scanning within a reasonable timeframe
                typically within five to seven business days depending on plan
                complexity, submitting first removal requests within a
                reasonable period following initial scanning completion
                generally within seven to ten business days of account
                activation, and providing immediate dashboard access with
                progress tracking functionality upon account creation. -->
              </p>
              <p [innerHTML]="'terms_of_use.section_4.p2' | translate">
                <!-- We maintain regular re-scanning schedules with data broker
                networks every ninety days minimum, though many brokers are
                checked more frequently based on their data collection patterns.
                We provide progress updates through dashboard notifications and
                periodic email summaries, respond to customer support inquiries
                within one to two business days for standard requests with
                priority support available for higher-tier plans, and maintain
                reasonable service availability for dashboard access and core
                functionality. -->
              </p>
              <p [innerHTML]="'terms_of_use.section_4.p3' | translate">
                <!-- Data broker response times vary significantly based on
                individual company policies, legal requirements, verification
                procedures, and current request volumes. Some brokers respond
                within seven to fourteen days while others may require thirty to
                ninety days for full compliance. We implement automatic
                follow-up procedures for overdue removal requests, utilize
                alternative contact methods for persistently non-responsive
                brokers, maintain escalation procedures for challenging cases,
                and provide regular status updates through your dashboard. -->
              </p>
              <p [innerHTML]="'terms_of_use.section_4.p4' | translate">
                <!-- We track and monitor average removal success rates across
                different broker categories, average processing time for
                completed removal requests, customer satisfaction scores through
                feedback collection, and overall service uptime and technical
                performance indicators. Most users can expect significant
                reduction in their online presence within ninety to one hundred
                eighty days of service initiation, though some brokers may
                require multiple attempts over extended periods, and ongoing
                monitoring is essential for maintaining privacy protection over
                time. -->
              </p>
              <p [innerHTML]="'terms_of_use.section_4.p5' | translate">
                <!-- We cannot guarantee complete removal success as compliance
                depends on individual broker policies, immediate removal due to
                varying response times, prevention of re-listing as brokers may
                re-collect data over time, or removal from all possible sources
                as new brokers emerge regularly. Success rates are influenced by
                data broker internal policies, legal requirements for
                maintaining certain public information, technical failures at
                broker websites, and the accuracy of information provided during
                account setup. -->
              </p>
            </div>
            <div class="info-section">
              <h5 [innerHTML]="'terms_of_use.section_5.title' | translate">
                <!-- 5. Payment Terms and Billing -->
              </h5>
              <p [innerHTML]="'terms_of_use.section_5.p1' | translate">
                <!-- All subscriptions automatically renew ("rebill") according to
                the terms of your selected plan and continue until you cancel.
                We send a 30-day advance notice to your registered email address
                before any renewal charge, including clear instructions on how
                to cancel. -->
              </p>
              <p [innerHTML]="'terms_of_use.section_5.p2' | translate">
                <!-- We provide at least 30 days' advance written notice for any
                subscription price increases, sent to your registered email
                address. These notices clearly identify the current pricing, new
                pricing structure, effective date of the changes, and your
                options for responding. You may cancel your subscription before
                the price increase takes effect without penalty. Continued use
                after the effective date constitutes acceptance of the new
                pricing. -->
              </p>
              <p [innerHTML]="'terms_of_use.section_5.p3' | translate">
                <!-- Payment processing is handled by FastSpring®, our secure
                third-party processor. FastSpring® accepts major credit cards,
                PayPal, and other methods based on your location. It manages
                payment security, fraud prevention, and billing disputes, with
                immediate email confirmations and detailed receipts available in
                your account dashboard. -->
              </p>
              <p [innerHTML]="'terms_of_use.section_5.p4' | translate">
                <!-- State-Specific Rights -->
              </p>
              <p [innerHTML]="'terms_of_use.section_5.p5' | translate">
                <!-- California residents may cancel automatic renewals at any time
                without penalty under California Civil Code Section 1799.98. We
                disclose auto-renewal terms clearly at signup and provide easy
                cancellation options through multiple channels. -->
              </p>
              <p [innerHTML]="'terms_of_use.section_5.p6' | translate">
                <!-- New York residents receive clear disclosure of auto-renewal
                terms under New York General Business Law Section 527, with no
                unreasonable obstacles to cancellation and full contact
                information for support. -->
              </p>
              <p [innerHTML]="'terms_of_use.section_5.p7' | translate">
                <!-- Our auto-renewal practices comply with consumer protection laws
                in all states, preserving your state-specific rights. -->
              </p>
            </div>
            <div class="info-section">
              <h5 [innerHTML]="'terms_of_use.section_6.title' | translate">
                <!-- 6. Cancellation and Refund Policy -->
              </h5>
              <p [innerHTML]="'terms_of_use.section_6.p1' | translate">
                <!-- You can cancel your Removia subscription through several methods
                including accessing your account dashboard and selecting "Cancel
                Auto-Renewal" in Subscription Settings to stop future charges
                while maintaining service through your current billing period,
                sending a cancellation request to
                <a href="mailto:support@removia.io">support@removia.io</a> with
                "Subscription Cancellation" in the subject line, or contacting
                customer service during business hours for personalized
                assistance. -->
              </p>
              <p [innerHTML]="'terms_of_use.section_6.p2' | translate">
                <!-- Cancellation stops automatic renewal immediately upon
                processing, but service continues uninterrupted until the end of
                your current paid billing period. Data retention and processing
                continue according to our Privacy Policy during the remainder of
                your subscription period, and re-subscription is available at
                any time at current pricing with no penalties or restrictions. -->
              </p>
              <p [innerHTML]="'terms_of_use.section_6.p3' | translate">
                <!-- <b
                  >All Removia customers benefit from our comprehensive
                  fourteen-day money-back guarantee.</b
                >
                If you are not satisfied with our service for any reason within
                fourteen days of your initial purchase, you can request a full
                refund with no questions asked and no usage restrictions or
                arbitrary limitations. To request a refund, simply email
                <a href="mailto:support@removia.io">support@removia.io</a> with
                "Refund Request" in the subject line, including your account
                email address and subscription details. -->
              </p>
              <p [innerHTML]="'terms_of_use.section_6.p4' | translate">
                <!-- Approved refunds are processed within two to three business days
                of request approval and issued to your original payment method
                automatically. Processing time for refunds to appear in your
                account varies by payment provider but typically takes three to
                seven business days for credit cards and up to ten business days
                for other payment methods. If your original payment method is
                unavailable, we can arrange alternative refund methods. -->
              </p>
              <p [innerHTML]="'terms_of_use.section_6.p5' | translate">
                <!-- We may provide prorated refunds in exceptional circumstances
                including service being substantially unavailable due to
                technical issues on our end, service failing to perform as
                described due to errors in our processing, or other
                circumstances that significantly impact service delivery at our
                discretion. Refunds are not provided for requests made more than
                fourteen days after initial purchase, accounts terminated for
                Terms violations, service interruptions due to force majeure
                events, or normal variations in data broker response times. -->
              </p>
              <p [innerHTML]="'terms_of_use.section_6.p6' | translate">
                <!-- You may close your account at any time by contacting customer
                support, with account closure processed according to our Privacy
                Policy data retention schedule and no penalties or fees for
                early closure beyond the standard non-refundable nature of
                unused subscription periods. We reserve the right to terminate
                accounts for Terms violations with thirty days advance notice
                when possible, and terminated accounts are not eligible for
                refunds. You have the right to appeal termination decisions
                through our formal appeal process. -->
              </p>
            </div>
            <div class="info-section">
              <h5 [innerHTML]="'terms_of_use.section_7.title' | translate">
                <!-- 7. Prohibited Activities and Acceptable Use -->
              </h5>
              <p [innerHTML]="'terms_of_use.section_7.p1' | translate">
                <!-- When using Removia services, you must not create multiple
                accounts for the same individual, provide false or misleading
                information, attempt to remove information you do not own or
                lack authority to request removal of, use our service for
                commercial purposes without explicit authorization, or share
                account access with unauthorized persons. -->
              </p>
              <p [innerHTML]="'terms_of_use.section_7.p2' | translate">
                <!-- You must not interfere with or disrupt our services or technical
                infrastructure, attempt to gain unauthorized access to our
                systems or other user accounts, use automated tools in ways not
                intended by our platform design, reverse engineer or replicate
                our proprietary technology, use our service for unlawful
                purposes or in violation of applicable laws, violate
                intellectual property or privacy rights of third parties, or
                engage in fraudulent or deceptive practices. -->
              </p>
              <p [innerHTML]="'terms_of_use.section_7.p3' | translate">
                <!-- Effective data removal depends on the accuracy of information
                you provide. You must provide accurate and complete personal
                information during account setup and service use, update your
                information promptly when changes occur, respond quickly to
                verification requests from our team or data brokers, and ensure
                you only request removal of your own personal information or
                information for which you have proper authorization. -->
              </p>
              <p [innerHTML]="'terms_of_use.section_7.p4' | translate">
                <!-- Providing inaccurate information may prevent successful removal
                requests, delay service delivery, require additional
                verification steps, and in cases of repeated inaccuracies may
                result in service limitations or termination. You must comply
                with applicable data privacy laws, respect third-party rights
                and interests, follow data broker terms when they don't conflict
                with your privacy rights, and cooperate with legitimate legal
                processes. -->
              </p>
              <p [innerHTML]="'terms_of_use.section_7.p5' | translate">
                <!-- Our enforcement approach includes warnings for initial or minor
                violations with clear explanation and guidance for compliance,
                service suspension for serious violations or repeated minor
                violations while we investigate and work toward resolution,
                account termination for severe violations or persistent
                non-compliance after warnings, and legal action reserved for
                violations involving illegal activity or significant harm. -->
              </p>
              <p [innerHTML]="'terms_of_use.section_7.p6' | translate">
                <!-- You have the right to appeal any enforcement action through our
                formal appeal process, including written explanation of
                violations, opportunity to present your perspective and
                mitigating circumstances, review by senior management
                independent of initial enforcement, and clear communication of
                results with further options if available. Appeals should be
                submitted within thirty days of enforcement action. -->
              </p>
            </div>
            <div class="info-section">
              <h5 [innerHTML]="'terms_of_use.section_8.title' | translate">
                <!-- 8. Intellectual Property Rights -->
              </h5>
              <p [innerHTML]="'terms_of_use.section_8.p1' | translate">
                <!-- Removia owns and maintains exclusive rights to all intellectual
                property associated with our service, including website and
                platform content such as text, graphics, logos, images, and user
                interface designs, technology and software including proprietary
                applications, algorithms, data processing methodologies, and
                automation systems, branding and trademarks including the
                Removia name, logo, and distinctive branding elements, and
                business methods including our approaches to data broker
                communication and removal request methodologies. -->
              </p>
              <p [innerHTML]="'terms_of_use.section_8.p2' | translate">
                <!-- We grant you a limited, non-exclusive, non-transferable license
                to access and use our services strictly in accordance with these
                Terms for your personal, non-commercial use only, without
                conveying ownership rights in our intellectual property. You
                cannot reproduce, copy, distribute, or display our content
                without permission, use our trademarks or branding without
                authorization, reverse engineer or extract source code from our
                technology, or create derivative works based on our services. -->
              </p>
              <p [innerHTML]="'terms_of_use.section_8.p3' | translate">
                <!-- You retain full ownership of personal information and data you
                provide to us, and we do not claim ownership of your personal
                data. By using our service, you grant us a limited,
                non-exclusive license to use your personal information strictly
                for providing data removal services, including sharing your
                information with data brokers for removal requests, acting as
                your authorized agent in communications with data brokers, and
                processing your data for service delivery and account
                management. This license is limited to service delivery purposes
                and terminates upon account closure. -->
              </p>
              <p [innerHTML]="'terms_of_use.section_8.p4' | translate">
                <!-- Data brokers own their respective website content, removal
                procedures, and platform policies, and we do not control
                third-party content or procedures. Third-party terms may apply
                to removal requests, though these cannot override your
                fundamental privacy rights under applicable law. Our website may
                contain links to external websites not owned by Removia, and we
                do not endorse, control, or take responsibility for third-party
                websites or their content. -->
              </p>
            </div>
            <div class="info-section">
              <h5 [innerHTML]="'terms_of_use.section_9.title' | translate">
                <!-- 9. Disclaimers and Limitations of Liability -->
              </h5>
              <p [innerHTML]="'terms_of_use.section_9.p1' | translate">
                <!-- Removia warrants that our data removal services will be
                performed with reasonable care, skill, and professionalism in
                accordance with generally accepted industry standards. We commit
                to making commercially reasonable efforts to contact data
                brokers on your behalf, provide accurate and timely progress
                updates, maintain appropriate security measures to protect your
                information, and respond to customer inquiries promptly and
                professionally. -->
              </p>
              <p [innerHTML]="'terms_of_use.section_9.p2' | translate">
                <!-- Nothing in these Terms excludes, limits, or waives your
                statutory rights as a consumer under applicable law, including
                consumer protection legislation, warranty rights that cannot be
                disclaimed, and remedies for defective services. Our disclaimers
                and liability limitations do not apply to death or personal
                injury caused by our negligence, fraud or fraudulent
                misrepresentation, gross negligence or willful misconduct, or
                liability that cannot be legally excluded under consumer
                protection laws. -->
              </p>
              <p [innerHTML]="'terms_of_use.section_9.p3' | translate">
                <!-- While we use reasonable efforts to provide effective data
                removal services, we cannot control or guarantee third-party
                compliance with removal requests, as compliance depends on
                individual broker policies, legal interpretations, and internal
                procedures. Response timelines vary significantly based on
                broker-specific processing requirements and current volumes.
                Complete elimination of your information from all online sources
                is not feasible due to constantly evolving data collection,
                emergence of new brokers, and reappearance of information from
                public records. -->
              </p>
              <p [innerHTML]="'terms_of_use.section_9.p4' | translate">
                <!-- We commit to using reasonable commercial efforts but cannot
                guarantee complete removal success rates, specific timelines for
                individual requests, prevention of future data collection and
                re-listing, or availability of all broker removal mechanisms.
                Technical issues including third-party website problems and
                internet connectivity may affect service delivery beyond our
                control. -->
              </p>
              <p [innerHTML]="'terms_of_use.section_9.p5' | translate">
                <!-- Where permitted by applicable law, Removia's total liability for
                any claims arising from our service is limited to the lesser of
                the total amount you paid for your current subscription period
                or one hundred euros equivalent in your local currency. We are
                not liable for indirect, incidental, consequential, special, or
                punitive damages including loss of profits, business
                opportunities, data, or emotional distress, except where such
                limitations are prohibited by consumer protection laws. -->
              </p>
              <p [innerHTML]="'terms_of_use.section_9.p6' | translate">
                <!-- We are not liable for delays or failures due to circumstances
                beyond our reasonable control, including government actions or
                regulatory changes, technical failures of third-party systems,
                natural disasters or acts of war, or cyber attacks affecting
                third parties. During such events, we commit to reasonable
                efforts to minimize disruption, communicate with customers about
                expected resolution, provide appropriate remedies when
                warranted, and resume normal service as quickly as possible. -->
              </p>
            </div>
            <div class="info-section">
              <h5 [innerHTML]="'terms_of_use.section_10.title' | translate">
                <!-- 10. Privacy and Data Protection -->
              </h5>
              <p [innerHTML]="'terms_of_use.section_10.p1' | translate">
                <!-- Our detailed Privacy Policy governs all aspects of personal data
                collection, processing, storage, and sharing and is an integral
                part of these Terms. We commit to minimal data collection
                necessary for service delivery, no unauthorized sharing or
                commercial exploitation of your information, automatic data
                deletion twelve months after subscription termination unless
                earlier deletion is requested, and appropriate security measures
                throughout processing. -->
              </p>
              <p [innerHTML]="'terms_of_use.section_10.p2' | translate">
                <!-- You have fundamental rights regarding your personal information
                including access to data we hold about you, correction of
                inaccurate information, deletion of your personal data subject
                to legal retention requirements, data portability in electronic
                format, and opt-out from marketing communications while
                maintaining service functionality. -->
              </p>
              <p [innerHTML]="'terms_of_use.section_10.p3' | translate">
                <!-- EU, EEA, and UK residents have enhanced GDPR rights including
                detailed information about processing purposes, objection to
                processing based on legitimate interests, restriction of
                processing in specific circumstances, withdrawal of consent for
                consent-based processing, and complaints to data protection
                supervisory authorities. -->
              </p>
              <p [innerHTML]="'terms_of_use.section_10.p4' | translate">
                <!-- California residents have CCPA rights including knowledge of
                information categories collected and shared, access to specific
                personal information collected in the past twelve months,
                deletion of personal information subject to legal exceptions,
                and non-discrimination protection for exercising privacy rights. -->
              </p>
              <p [innerHTML]="'terms_of_use.section_10.p5' | translate">
                <!-- Japanese residents have rights under the Act on the Protection
                of Personal Information (APPI). These include the right to
                request disclosure of personal information, correction of
                inaccurate information, suspension of use, or deletion where
                permitted by law. Requests can be submitted to
                privacy@gotyourbacksupport.com, and we will respond in
                accordance with APPI requirements. -->
              </p>
              <p [innerHTML]="'terms_of_use.section_10.p6' | translate">
                <!-- Additional Rights for Japanese Residents. Under Article 32 of
                APPI, we ensure that the procedure for exercising your rights
                does not impose an excessive burden on you. We: -->
              </p>
              <ul [innerHTML]="'terms_of_use.section_10.list1' | translate">
                <!-- <li>
                  Provide multiple channels for submitting requests (email,
                  dashboard, support)
                </li>
                <li>Process requests without unnecessary verification steps</li>
                <li>Respond within the timeframes required by APPI</li>
                <li>
                  Provide clear information to help you specify which data you
                  want to access
                </li> -->
              </ul>
              <p [innerHTML]="'terms_of_use.section_10.p7' | translate">
                <!-- If we cannot comply with your request, we will provide an
                explanation in accordance with Article 31 of APPI. -->
              </p>
              <p [innerHTML]="'terms_of_use.section_10.p8' | translate">
                <!-- We process data to provide removal services, verify identity,
                track progress, manage accounts, improve services, prevent
                fraud, and comply with legal obligations. Our processing is
                based on contract performance for service delivery, legitimate
                interests for improvement and security, consent for marketing
                communications, and legal compliance obligations. -->
              </p>
            </div>
            <div class="info-section">
              <h5 [innerHTML]="'terms_of_use.section_11.title' | translate">
                <!-- 11. Dispute Resolution and Governing Law -->
              </h5>
              <p [innerHTML]="'terms_of_use.section_11.p1' | translate">
                <!-- These Terms are governed by and construed in accordance with the
                laws of England and Wales, providing a stable legal framework
                for commercial relationships and consumer protection. Where you
                are protected by mandatory consumer protection laws in your
                jurisdiction that provide greater protection than English law,
                those local laws take precedence over conflicting provisions. -->
              </p>
              <p [innerHTML]="'terms_of_use.section_11.p2' | translate">
                <!-- Before initiating formal legal proceedings, both parties agree
                to attempt good faith resolution through direct communication
                with our customer service team, escalation to senior management
                for complex issues, and a thirty-day informal resolution period
                with documentation of resolution attempts. -->
              </p>
              <p [innerHTML]="'terms_of_use.section_11.p3' | translate">
                <!-- If informal resolution proves unsuccessful, EU and EEA residents
                may utilize alternative dispute resolution mechanisms provided
                by relevant authorities or bring proceedings in courts of their
                country of residence as provided under applicable law. UK
                residents may access relevant ombudsman services or bring
                proceedings in UK courts. US residents are subject to
                state-specific dispute resolution requirements and consumer
                protection procedures. Other jurisdictions have local dispute
                resolution mechanisms available under applicable law. -->
              </p>
              <p [innerHTML]="'terms_of_use.section_11.p4' | translate">
                <!-- The courts of England and Wales have primary jurisdiction over
                disputes arising from these Terms, though your right to bring
                proceedings in your country of residence is preserved where
                provided by consumer protection law. Where legally permitted,
                disputes should be resolved individually rather than through
                class actions, though this does not apply where prohibited by
                mandatory consumer protection laws. -->
              </p>
              <p [innerHTML]="'terms_of_use.section_11.p5' | translate">
                <!-- Legal actions must generally be commenced within two years of
                the claim arising, though consumer protection laws may provide
                different limitation periods, and the discovery rule may apply
                to claims not immediately apparent. -->
              </p>
            </div>
            <div class="info-section">
              <h5 [innerHTML]="'terms_of_use.section_12.title' | translate">
                <!-- 12. General Provisions -->
              </h5>
              <p [innerHTML]="'terms_of_use.section_12.p1' | translate">
                <!-- We may update these Terms to reflect changes in applicable law
                or regulatory requirements, new service features or
                modifications, enhanced user protections based on feedback, and
                business practice updates that improve service delivery.
                Material changes affecting your rights receive thirty days
                advance notice through email and dashboard notifications, while
                minor clarifications are posted immediately with clear effective
                dates. -->
              </p>
              <p [innerHTML]="'terms_of_use.section_12.p2' | translate">
                <!-- Upon notification of changes, you may continue using our service
                which constitutes acceptance, contact us to discuss concerns
                before changes take effect, cancel your service if you disagree
                with material changes, or exercise legal rights unaffected by
                Terms changes. -->
              </p>
              <p [innerHTML]="'terms_of_use.section_12.p3' | translate">
                <!-- If any provision is determined invalid or unenforceable, the
                remainder remains in full effect, with invalid provisions
                interpreted to achieve their intended purpose when possible.
                Consumer protection provisions cannot be severed where required
                by law. Our failure to enforce provisions does not waive future
                enforcement rights, though consumer rights cannot be waived
                where prohibited. -->
              </p>
              <p [innerHTML]="'terms_of_use.section_12.p4' | translate">
                <!-- These Terms, together with our Privacy Policy, constitute the
                complete agreement between you and Removia superseding all prior
                understandings. No modifications are valid unless made according
                to our amendment procedures, and oral modifications are not
                binding. -->
              </p>
              <p [innerHTML]="'terms_of_use.section_12.p5' | translate">
                <!-- We may assign our rights and obligations in connection with
                business mergers, acquisitions, or restructuring, with
                appropriate protections for your rights and service
                continuation. You cannot assign your rights or account access,
                as your personal use license is non-transferable and terminates
                upon attempted assignment. -->
              </p>
              <p [innerHTML]="'terms_of_use.section_12.p6' | translate">
                <!-- Payment obligations for services received, intellectual property
                protections, limitation of liability provisions where legally
                permitted, and dispute resolution procedures survive account
                termination and continue to bind both parties. -->
              </p>
            </div>
            <div class="info-section">
              <h5 [innerHTML]="'terms_of_use.section_13.title' | translate">
                <!-- 13. Contact Information -->
              </h5>
              <p [innerHTML]="'terms_of_use.section_13.p1' | translate">
                <!-- For general support, contact
                <a href="mailto:support@removia.io">support@removia.io</a> with
                response within one to two business days during business hours
                Monday through Friday, nine AM to six PM UTC. For privacy
                matters, contact
                <a href="mailto:privacy@gotyourbacksupport.com"
                  >privacy@gotyourbacksupport.com</a
                >, and for GDPR inquiries contact
                <a href="mailto:privacy@gotyourbacksupport.com"
                  >privacy@gotyourbacksupport.com</a
                >
                with response within thirty days as required by law. -->
              </p>
              <p [innerHTML]="'terms_of_use.section_13.p2' | translate">
                <!-- Legal notices should be sent to
                <a href="mailto:privacy@gotyourbacksupport.com"
                  >privacy@gotyourbacksupport.com</a
                >
                for Terms questions,
                <a href="mailto:privacy@gotyourbacksupport.com"
                  >privacy@gotyourbacksupport.com</a
                >
                for copyright concerns, and
                <a href="mailto:privacy@gotyourbacksupport.com"
                  >privacy@gotyourbacksupport.com</a
                >
                for compliance inquiries. For urgent security issues, contact
                <a href="mailto:privacy@gotyourbacksupport.com"
                  >privacy@gotyourbacksupport.com</a
                >
                with response within two hours during business hours and
                emergency escalation available after hours. -->
              </p>
              <p [innerHTML]="'terms_of_use.section_13.p3' | translate">
                <!-- GotYourBack Technologies Ltd. is located at Ifigeneias 14, 3036
                Limassol, Cyprus. Company registration details are available
                upon request, and VAT identification numbers are available for
                business customers. -->
              </p>
            </div>
            <div class="info-section">
              <h5 [innerHTML]="'terms_of_use.section_14.title' | translate">
                <!-- 14. Acknowledgment and Acceptance -->
              </h5>
              <p [innerHTML]="'terms_of_use.section_14.p1' | translate">
                <!-- By creating a Removia account, subscribing to our services, or
                using our platform, you acknowledge that you have read and
                understand these Terms and our Privacy Policy, meet all
                eligibility requirements including age and legal capacity, agree
                to be legally bound by these Terms and applicable laws, and
                understand your rights and responsibilities as outlined above. -->
              </p>
              <p [innerHTML]="'terms_of_use.section_14.p2' | translate">
                <!-- These Terms are effective as of June 16, 2025, and supersede all
                previous versions. The English language version is authoritative
                for all legal purposes, and any translations are for convenience
                only with the English version governing in case of conflicts. We
                recommend periodic review as Terms may change, and continued use
                after changes constitutes acceptance of updates. -->
              </p>
              <p [innerHTML]="'terms_of_use.section_14.p3' | translate">
                <!-- Thank you for choosing Removia to protect your privacy. We are
                committed to providing excellent service while respecting your
                rights and maintaining appropriate data protection standards. -->
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<app-landing-footer></app-landing-footer>
